<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps, inject, ref } from 'vue';
import { formatAmount } from '@/utils/formatters';
import { useMarketCartStore } from '@/stores/cart.store';
import { showAlert } from '@/utils/swal';
import router from '@/router';

const BACKEND_URL = inject('BACKEND_URL');
const props = defineProps({
    produit: { type: Object, required: true },
    layout: { type: String, default: 'none' },
});
const cart = useMarketCartStore();
const loadingCart = ref(false);

async function addProductToCart() {
    if (loadingCart.value) { return; }

    loadingCart.value = true;
    try {
        if (props.produit.mode_paiement === 'comptant' || props.produit.mode_paiement === 'echelonne') {
            await cart.addToCart({
                id: props.produit.id,
                nom: props.produit.nom,
                image: props.produit.image,
                montant: props.produit.montant,
                type_promotion: props.produit.type_promotion,
                taux_promotion: props.produit.taux_promotion,
                valeur_promotion: props.produit.valeur_promotion,
                montant_apres_remises: props.produit.montant_apres_remises,
                mode_paiement: props.produit.mode_paiement,
                montant_echeance: 0,
                nb_echeance: 0,
                total_promotion: 0,
                sous_total: 0,
                total: 0,
                total_echeance: 0,
            });
        } else {
            router.push((props.layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id);
        }
    } catch(error: any) {
        await showAlert.error(typeof error === 'string' ? error : 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
        loadingCart.value = false;
    }
}

</script>
<template>
    <div class="card-product zoom">
        <div class="img-area">
            <div class="tag-set justify-content-end" v-if="props.produit.type_promotion == 'PERCENTAGE' && props.produit.taux_promotion">
                <div class="tag2">-{{ Math.round(props.produit.taux_promotion) }}%</div>
                <!-- <div class="tag-promo">Promo !</div> -->
            </div>
            <div class="btn-set">
                <button class="btn-ultra lg btn-panier" :class="{'loading': loadingCart}" @click="addProductToCart"><!-- loading-->
                    <div class="btn-show">
                        <img src="/public/icons/icon-panier.svg" class="btn-icon" alt="" />
                    </div>
                    <div class="btn-loading">
                        <div class="loader-dots"></div>
                    </div>
                </button>
            </div>
            <router-link :to="(layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id" style="height: 290px;display: flex;justify-content: center;align-items: center;padding: 20px;">
                <img :src="BACKEND_URL + '/assets/market_produits/300/' + props.produit.image" class="img" style="max-width: 80%; max-height: 100%;" />
            </router-link>
        </div>
        <router-link :to="(layout == 'frontoffice' ? '/front/market/produits/' : '/market/produits/') + props.produit.id">
            <div class="text-area">
                <!-- <h6 class="subtitle">Accessoire Xbox</h6> -->
                <h5 class="title secondary-font">{{ props.produit.nom }}</h5>
                <h3 class="price secondary-font">{{ formatAmount(props.produit.montant_apres_remises) }} <span class="secondary-font">F</span></h3>
            </div>
        </router-link>
    </div>
</template>